export interface CampaignFormData {
  title: string;
  category: string;
  location: string;
  shortDesc: string;
  story: string;
  coverImageUrl: string;
  tags: string;
  twitter: string;
  instagram: string;
  youtube: string;
  goalAmount: string;
  duration: string;
  iban: string;
}

export const initialFormData: CampaignFormData = {
  title: '',
  category: '',
  location: '',
  shortDesc: '',
  story: '',
  coverImageUrl: '',
  tags: '',
  twitter: '',
  instagram: '',
  youtube: '',
  goalAmount: '',
  duration: '30',
  iban: '',
};
